import mustache from "mustache";
import { IInputReadonlyField } from "../../../definitions/form/inputs/IInputReadonlyField";
import { ReadonlyConfig } from "../../../definitions/form/inputs/config/ReadonlyConfig";
import template from "./template.html";

mustache.parse(template);

/** Contador para ids únicos por instancia. */
let READONLY_FIELD_ID = 0;

/** Campo de solo lectura (Render/Connect): misma caja que un input editable
 *  (`sx-field` + `sx-input`), pero deshabilitado. El valor se actualiza en vivo
 *  con `setValue`. */
export class InputReadonlyField implements IInputReadonlyField {
  /** Id único de la instancia (para el input del DOM). */
  private readonly _fieldId: number;

  constructor(private readonly _config: ReadonlyConfig) {
    READONLY_FIELD_ID += 1;
    this._fieldId = READONLY_FIELD_ID;
  }

  render(): string {
    return mustache.render(template, {
      label: this._config.label,
      description: this._config.description ?? "",
      value: this._config.value ?? "",
      id: this._fieldId,
    });
  }

  /** Captura el input para actualizarlo en vivo. */
  connect(): void {
    this._input = document.getElementById(
      `input-${this._fieldId}`,
    ) as HTMLInputElement;
  }

  dispose(): void {}

  /** Actualiza el valor mostrado. */
  setValue(value: string | null): void {
    if (this._input) this._input.value = value ?? "";
  }

  private _input: HTMLInputElement | null = null;
}
